import { ButtonBase, Divider, List, ListItemAvatar, ListItemIcon, ListItemText, Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';
import { IStoreState, ThunkDispatch } from '../../modules';
import React, { Component } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { faChartPie, faHandHoldingUsd, faLink, faSignOutAlt, faUniversity, faUserFriends, faUserLock } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ListItem from '@material-ui/core/ListItem';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { generateAvatar } from '../../helpers/user';
import { logout } from '../../modules/auth';
import { proxyBase } from '../../modules/config';
import { push } from 'connected-react-router';

const styles = (theme: Theme) => createStyles({
  listItemIcon: {
    margin: `0 ${theme.spacing(1)}px`,
    width: `${theme.spacing(1)}px`,
    minWidth: `${theme.spacing(5)}px`,
    "& > *": {
      margin: '0 auto',
    },
  },
  avatar: {
    margin: `0 ${theme.spacing(1)}px`,
  },
  divider: {
    margin: `${theme.spacing(1)}px 0`,
  },
})

class PibMenu extends Component<Props, {}> {
  static menuItems = [
    {
      text: 'Overview',
      icon: faChartPie,
      path: '/pib/overview',
    },
    {
      text: 'My Accounts',
      icon: faUniversity,
      path: '/pib/accounts',
    },
    {
      text: 'Make a Transfer',
      icon: faHandHoldingUsd,
      path: '/pib/transfer',
    },
    {
      text: 'Manage Payees',
      icon: faUserFriends,
      path: '/pib/payees',
    },
  ];

  static securityMenuItems = [
    {
      text: 'Device Bindings',
      icon: faLink,
      path: '/pib/bindings',
      visible: (_this: PibMenu) => ["proxy", "direct"].includes(_this.props.config.aa.mode || ""),
    },
    {
      text: 'Authentication',
      icon: faUserLock,
      path: '/pib/authentications',
      visible: (_this: PibMenu) => ["proxy", "direct"].includes(_this.props.config.aa.mode || ""),
    },
  ]

  redirectTo = (url: string) => () => {
    this.props.push(url)
    if (this.props.itemClick)
      this.props.itemClick()
  }

  clickLogout = () => {
    const { proxyBase } = this.props
    this.props.logout().then(() => {
      this.props.push(proxyBase())
    })
    if (this.props.itemClick)
      this.props.itemClick()
  }

  render = () => {
    const { auth, classes, location, proxyBase } = this.props

    const currentPath = location.pathname

    return (
      <List>
        <ListItem>
          <ListItemAvatar className={classes.avatar}>
            {generateAvatar(auth.userName)}
          </ListItemAvatar>
          <ListItemText
            primary={auth.userName}
            secondary={
              <ButtonBase onClick={this.clickLogout}><FontAwesomeIcon icon={faSignOutAlt} /> &nbsp; Sign Out</ButtonBase>}
          />
        </ListItem>
        <Divider className={classes.divider} />
        {PibMenu.menuItems.map((v, k) => (
          <ListItem button key={k} onClick={this.redirectTo(proxyBase(v.path))} selected={currentPath === v.path}>
            <ListItemIcon className={classes.listItemIcon}>
              <FontAwesomeIcon icon={v.icon} fixedWidth />
            </ListItemIcon>
            <ListItemText primary={v.text} />
          </ListItem>
        ))}
        <Divider className={classes.divider} />
        {PibMenu.securityMenuItems.filter(v => {
          let visible = _.get(v, 'visible', true)
          return typeof visible === "function" ? visible(this) : visible
        }).map((v, k) => (
          <ListItem button key={k} onClick={this.redirectTo(proxyBase(v.path))} selected={currentPath === v.path}>
            <ListItemIcon className={classes.listItemIcon}>
              <FontAwesomeIcon icon={v.icon} fixedWidth />
            </ListItemIcon>
            <ListItemText primary={v.text} />
          </ListItem>
        ))}
      </List>
    )
  }
}

const mapStateToProps = ({ auth, intl, config }: IStoreState) => ({
  auth,
  intl,
  config
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      logout,
      push,
      proxyBase
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps>, RouteComponentProps<{}> {
  itemClick?(): void
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(PibMenu)));